module.exports = __webpack_public_path__ + "static/media/Raleway-SemiBold.87641f99.ttf";